var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plan_override_exists)?_c('div',{staticClass:"w-100 h-100 d-flex justify-content-center align-items-center pr-3"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-ss",attrs:{"href":"/user/revert-plan-type-override"}},[_c('i',{staticClass:"la la-close"}),_vm._v("Revert Plan Type\n  ")])
}]

export { render, staticRenderFns }